import Vue from 'vue'
import linkify from 'vue-linkify'
Vue.directive('linkified', linkify)